import React, { useState } from 'react';
import Navbar from './Navbar';
import Brochure from './Brochure';
import EnessaLogo from '../assets/logo/Enessa-Logo-2.png';
import { Link } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="relative z-10 p-4 bg-white lg:px-8 lg:bg-transparent">
        <div className="flex items-center gap-4">

          {/* LOGO */}
          <div className="flex-shrink-0">
            <Link to="/">
              <img src={EnessaLogo} alt="logo" className="h-20" />
            </Link>
          </div>

          {/* NAVBAR */}
          <Navbar />

          {/* RIGHT SIDE */}
          <div className="items-center hidden gap-3 lg:flex">

            {/* ✅ FIXED: use component directly */}
            <Brochure />

            <Link
              to="/contact#inquiry-section"
              className="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-full hover:bg-red-600"
            >
              Enquiry Form
            </Link>
          </div>

          {/* MOBILE MENU BUTTON */}
          <button
            className="p-2 ml-auto lg:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            ☰
          </button>
        </div>

        {/* MOBILE MENU */}
        {mobileMenuOpen && (
          <div className="p-4 mt-4 bg-white rounded-lg shadow-lg lg:hidden">

            <div className="space-y-2">
              <Brochure />

              <Link
                to="/contact"
                onClick={() => setMobileMenuOpen(false)}
                className="block w-full px-4 py-2 text-center text-white bg-red-500 rounded-full"
              >
                Enquiry Form
              </Link>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;